module.exports = __webpack_public_path__ + "img/timesheet.bc8bc52d.png";